"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var layout_1 = require("../../layout");
var Text_1 = __importDefault(require("../../Text"));
var BaseAvatarInternal_1 = __importDefault(require("./BaseAvatarInternal"));
var styles_1 = require("./styles");
var AVATAR_SIZE_TO_TITLE_SIZE = {
    sm: 'sm',
    md: 'default',
    lg: 'lg',
    xl: 'xl',
};
var AVATAR_SIZE_TO_BODY_SIZE = {
    sm: 'sm',
    md: 'sm',
    lg: 'default',
    xl: 'default',
};
var AvatarLabeled = function (props) {
    var _a = props.size, size = _a === void 0 ? 'md' : _a, label = props.label, subLabel = props.subLabel, rest = __rest(props, ["size", "label", "subLabel"]);
    return (react_1.jsx(layout_1.Flex, { gap: 8 },
        react_1.jsx(BaseAvatarInternal_1.default, __assign({}, rest, { wrapperSize: styles_1.sizesMap[size].root, indicatorSize: styles_1.sizesMap[size].indicator, fontSize: styles_1.sizesMap[size].font, iconSize: styles_1.sizesMap[size].iconFont })),
        react_1.jsx(layout_1.Flex, { direction: "column" },
            react_1.jsx(Text_1.default.Title, { size: AVATAR_SIZE_TO_TITLE_SIZE[size] }, label),
            react_1.jsx(Text_1.default.Body, { size: AVATAR_SIZE_TO_BODY_SIZE[size] }, subLabel))));
};
exports.default = AvatarLabeled;
